import { css } from '@linaria/core';
import theme from '../../../theme';

export const variants = {
  disabled: css``,
  hover: css``,
  selected: css``,
  open: css``,
};
export const components = {
  trigger: css``,
  placeholder: css``,
  display: css``,
  content: css``,
  icon: css``,
  item: css`
    &:hover {
      background: ${theme.colors.peoople['azul-claro']};
    }

    &.${variants.hover} {
      background: ${theme.colors.peoople['azul-claro']};
    }

    &.${variants.selected} {
      background: ${theme.colors.peoople['azul-claro']};
      color: ${theme.colors.peoople['azul-claro-medio']};
    }
  `,
  control: css``,
};

export const select = css`
  width: 100%;

  & .${components.control} {
    width: 100%;
  }

  & .${components.trigger} {
    width: 100%;
    cursor: pointer;

    &.${variants.disabled} {
      cursor: not-allowed;
    }
  }

  &.${variants.open} .${components.icon} {
    rotate: 90deg;
  }

  & .${components.placeholder} {
  }

  & .${components.display} {
    overflow: hidden;
    white-space: nowrap;
    display: block;
    text-overflow: ellipsis;
  }

  & .${components.content} {
    max-height: 215px;
  }

  & .${components.icon} {
    color: ${theme.colors.peoople['gris-medio']};
    transition: transform 0.125s ease-in;
    pointer-events: none;
    font-size: 12px;
    rotate: -90deg;
    transition: rotate 0.125s ease-in;
    &[disabled] {
      color: ${theme.colors.neutral['60']};
    }
  }

  cursor: pointer;
`;
